module.exports = __webpack_public_path__ + "img/doc_connectapp.299cddd2.gif";